export function findLast<T>(a: T[], predicate?: (e: T) => boolean) {
    if (!predicate) {
        return a[a.length - 1]
    }
    for (let index = a.length - 1; index >= 0; index--) {
        if (predicate(a[index])) {
            return a[index]
        }
    }
    return undefined
}

export function isFunctionalComponent(possibleComponent: any): possibleComponent is (...args: any[]) => any {
    return typeof possibleComponent === 'function' || possibleComponent?.type?.name === 'wrappedComponent'
}

